<template lang="pug">

  div

    v-dialog(v-model="visible" max-width="360px" width="100%" persistent)

      .dialogHeader

        .dialogHeaderTitle
          | Escolha o tipo de consulta

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close('CLOSED')")

      .dialogBody

        .dialogBodyContent

          div
            label.csLabel.csLabel--heightFix
              | Tipo de consulta:
            .radioButtons.mt-2
              div
                sos-radio(id="first_appointment" name="periodo" label="Primeira consulta" :checked="slotType" :value="'FIRST_APPOINTMENT'" @click="onSlotTypeChange").sosCheckbox--slotType
              .mt-3
                sos-radio(id="follow_up" name="periodo" label="Retorno" :checked="slotType" :value="'FOLLOW_UP'" @click="onSlotTypeChange").sosCheckbox--slotType
              .mt-3
                sos-radio(id="free" name="periodo" label="Ambos" :checked="slotType" :value="'FREE'" @click="onSlotTypeChange").sosCheckbox--slotType

          //- .fieldNote.mt-4
          .infoBox.mt-4
            i(aria-hidden="true" class="mdi mdi-information" style="font-size: 16px; vertical-align: bottom;")
            |  Defina o tipo de vaga que o plantão vai projetar no Portal Consultas.

          .text-right.mt-5
            sos-button(@buttonClick="close('CLOSED')" size="medium" buttonLabel="Cancelar" buttonIcon="mdi-close" buttonIconSize="16" color="blue").mr-3
            sos-button(@buttonClick="confirm" size="medium" buttonLabel="Confirmar" buttonIcon="mdi-check" buttonIconSize="16" color="success")

</template>

<script>

  import SosButton from "@/components/SosButton"
  import SosRadio from "@/components/SosRadio"

  export default {
    name: "ConsultationTypePicker",

    components: {
      "sos-button": SosButton,
      "sos-radio": SosRadio,
    },

    /* mixins: [
    ], */

    data () {
      return {
        visible: false,
        slotType: "FIRST_APPOINTMENT", // FIRST_APPOINTMENT | FOLLOW_UP | FREE
        event: "",
        payload: null,
      }
    },

    beforeDestroy () {
      this.clear()
    },

    methods: {
      reset ()
      {
        this.visible = false
        this.slotType = "FIRST_APPOINTMENT"
        this.event = ""
        this.payload = null
      },

      clear ()
      {
        this.reset()

        // Bloco comentado por recomendação do GPT
        // delete this.visible
        // delete this.slotType
        // delete this.event
        // delete this.payload
      },

      open (event, payload = null)
      {
        console.log("::: ConsultationTypePicker.vue => OPEN:", event, payload)

        if (this.visible) {
          console.warn("Modal já aberto — ignorando nova abertura")
          return
        }

        this.reset()

        // this.slotType = "FIRST_APPOINTMENT"
        this.event = event
        this.payload = payload

        this.visible = true
      },

      close (selected)
      {
        const rawData = {
          status: selected,
          slotType: this.slotType,
          event: this.event,
          payload: this.payload
        }

        this.$emit("close", rawData)

        this.reset()
      },

      onSlotTypeChange (value)
      {
        // console.log("::: ConsultationTypePicker.vue => value:", value)

        this.slotType = value
      },

      confirm ()
      {
        this.close("CONFIRMED")
      },
    },
  }
</script>

<style lang="scss">

  .sosCheckbox--slotType.sosCheckbox .sosCheckboxLabel {
    padding-left: 7px;
    font-size: 15px;
  }

</style>
